// Vendor imports
const qs = require('qs')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const { normalizeExternalHref } = require('client-v2/common/state/router/utils')

// Action types

const CLOSE = 'STUMBLE_UPON_SUBMIT_MODAL_CLOSE'
const OPEN = 'STUMBLE_UPON_SUBMIT_MODAL_OPEN'

// Action creators

function close() {
  return { type: CLOSE }
}

function open(url) {
  return {
    type: OPEN,
    payload: {
      url: normalizeExternalHref(url)
    }
  }
}

// Action dispatchers

function maybeOpen() {
  return async function (dispatch, getState) {
    const { router } = getState()
    const queryParams = qs.parse(router.location.search, {
      ignoreQueryPrefix: true
    })
    if (queryParams.su === 'submit') {
      dispatch(open(queryParams.url))
      await businessEvents.trackSegment('su-submit-modal')
    }
  }
}

module.exports = {
  // Action types
  CLOSE,
  OPEN,
  // Action creators
  close,
  open,
  // Action dispatchers
  maybeOpen
}
